"use client";
import Link from "next/link";
import { usePagination } from "react-instantsearch";

import { Container } from "@/components/Blog/Layout";
import NavigationButton from "./NavigationButton";
const SearchNavigation = () => {
  const { currentRefinement, isFirstPage, isLastPage, refine, createURL } =
    usePagination();

  const goToPage = (page: number) => {
    refine(page);
    window.scrollTo({ top: 0 });
  };

  return (
    <Container className="grid grid-cols-2">
      <div>
        {!isFirstPage && (
          <Link
            href={createURL(currentRefinement - 1)}
            onClick={() => goToPage(currentRefinement - 1)}
          >
            <NavigationButton>Newer Posts</NavigationButton>
          </Link>
        )}
      </div>
      <div className="text-right">
        {!isLastPage && (
          <Link
            href={createURL(currentRefinement + 1)}
            onClick={() => goToPage(currentRefinement + 1)}
          >
            <NavigationButton>Older Posts</NavigationButton>
          </Link>
        )}
      </div>
    </Container>
  );
};

export default SearchNavigation;
